import React from "react";

import * as styles from "../FormPreview.module.css";

type ApplicationInformationSharedRowContentProps = {
  question?: string;
  answers?: string | number | Array<string> | Array<Array<string>>;
  keyOfObject?: string;
  id?: string;
  isAnswerWithHtmlContent?: boolean;
};

export const ApplicationInformationSharedRowContent = ({
  id = "",
  question,
  answers,
  keyOfObject,
  isAnswerWithHtmlContent,
}: ApplicationInformationSharedRowContentProps) => {
  const renderQuestionLabel = <td className={styles.tdFirst}>{question ?? ""}</td>;

  const renderAsArray = (answersAsArray: Array<string> | Array<Array<string>>) => {
    const valueIsAlsoAnArray = (value: string[], index: number) =>
      value.map((data, childIndex) =>
        childIndex === value.length - 1 ? (
          <div className={styles.trArrayLast} key={`${index}${childIndex}`}>
            {data}
          </div>
        ) : (
          <div key={`${index}${childIndex}`}>{data}</div>
        )
      );

    return (
      <td className={styles.trArrayFirst}>
        {answersAsArray.map((value, index) => {
          if (Array.isArray(value)) {
            return valueIsAlsoAnArray(value, index);
          }
          if (typeof value === "object" && keyOfObject) {
            return <div key={index}>{value[keyOfObject]}</div>;
          }
          return (
            <div className={styles.trArray} key={index}>
              {value}
            </div>
          );
        })}
      </td>
    );
  };

  const renderAnswer = () => {
    if (answers && Array.isArray(answers)) {
      return renderAsArray(answers);
    }

    if (answers && isAnswerWithHtmlContent && typeof answers === "string") {
      return (
        <td>
          <div dangerouslySetInnerHTML={{ __html: answers }} />
        </td>
      );
    }

    return <td>{answers}</td>;
  };

  const checkIfTheAnswerIsEmpty = () => {
    if (!answers) {
      return true;
    }

    if (typeof answers === "string" && answers.length === 0) {
      return true;
    }

    if (
      Array.isArray(answers) &&
      (answers.length === 0 ||
        (answers.length > 0 &&
          typeof answers[0] === "object" &&
          Object.keys(answers[0]).length === 0))
    ) {
      return true;
    }
    return false;
  };

  return checkIfTheAnswerIsEmpty() ? null : (
    <tr className={styles.tr} key={id}>
      {renderQuestionLabel}
      {renderAnswer()}
    </tr>
  );
};
